<template>
  <div class="main jcc ais">
    <div class="main__block">
      <div class="title">選擇果酸項目</div>
      <div v-if="showReferralCodeCard && referralCodeData && referralCodeData.checked" class="referral-card" style="margin-bottom: 20px;">
        <div class="referral-code-block">
          <div class="referral-label">推薦碼</div>
          <div class="referral-code">{{ referralCodeData.referral_code }}</div>
        </div>
        <div class="referral-divider"></div>
        <div class="referral-period-block">
          <div class="referral-label">活動期間</div>
          <div class="referral-period">{{ referralCodeData.res_data.campaign_info.start }} 至 {{ referralCodeData.res_data.campaign_info.end }}</div>
        </div>
      </div>
      <!-- <span class="desc">預估時間：<span>{{ needTime.schlen }}分鐘</span></span> -->
      <div class="flex f-col jcs ais w-100">
        <div class="part__body">
          <div class="choose__item square">
            <input v-model="tempAcid" value="醫療級果酸+清痘(25分鐘) 1200" type="radio" />
            <div class="checkTag">
              <span>醫療級果酸+清痘(25分鐘)<br>1200</span>
            </div>
          </div>
          <div class="choose__item square">
            <input v-model="tempAcid" value="醫療級清痘(45分鐘) 1500" type="radio" />
            <div class="checkTag">
              <span>醫療級清痘(45分鐘)<br>1500</span>
            </div>
          </div>
          <div class="choose__item square">
            <input v-model="tempAcid" value="醫療級果酸+清痘(45分鐘) 1800" type="radio" />
            <div class="checkTag">
              <span>醫療級果酸+清痘(45分鐘)<br>1800</span>
            </div>
          </div>
          <div class="choose__item square">
            <input v-model="tempAcid" value="醫療級果酸+清痘+導入(45分鐘) 2200" type="radio" />
            <div class="checkTag">
              <span>醫療級果酸+清痘+導入(45分鐘)<br>2200</span>
            </div>
          </div>
          <div class="choose__item square">
            <input v-model="tempAcid" value="身體果酸(30分鐘) 2500起" type="radio" />
            <div class="checkTag">
              <span>身體果酸(30分鐘)<br>2500起</span>
            </div>
          </div>
        </div>
        
        <div class="flex f-row jce w-100">
          <div @click="chooseTime" class="btn next">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import airleeClinicList from '../config/airleeClinicList';
export default {
  name: 'ChooseAcid',
  components: {},
  data() {
    return {
      tempAcid: ''
    };
  },
  methods: {
    checkClinic() {
      const clinicCode = this.$route.query.clinicCode;
      if (clinicCode) {
        localStorage.setItem('clinicCode', clinicCode);
      } else {
        alert('診所代碼錯誤,請重新登入！');
        this.backToLogin();
      }
    },
    backToLogin() {
      const clinicCode = this.$route.query.clinicCode;
      this.$router.push(`/login?clinicCode=${clinicCode}`);
    },
    async chooseTime() {
      const clinicCode = localStorage.getItem('clinicCode');
      const { schlen, checkin } = this.needTime;
      if (schlen > 0 && checkin > 0) {
        try {
          await this.$store.dispatch('resvModule/setTime', { data: this.needTime, clinicCode, });
          await this.$store.dispatch('resvModule/setNote', { data: this.note, clinicCode, });
          this.$router.push(`/choose-time?clinicCode=${this.$route.query.clinicCode}`);
        } catch (e) {
          const tokenError = ['無效的token', 'token錯誤', '該token已失效'];
          if (tokenError.indexOf(e) > -1) {
            alert('請重新登入');
            this.$router.push(`/login?clinicCode=${clinicCode}`);
          } else if (e == 'his api not found') {
            alert('請重新登入');
            this.$router.push(`/login?clinicCode=${clinicCode}`);
          } else {
            alert(e);
          }
        }
      } else if (schlen == null && checkin == null) {
        alert('尚未選擇項目！');
      }
    },
  },
  computed: {
    ...mapGetters('authModule', ['customerByC', 'mgmIsEnableByC']),
    ...mapGetters('resvModule', ['roomByC']),
    ...mapGetters('mgmModule', ['referralCodeDataByC']),
    customer() {
      const clinicCode = this.$route.query.clinicCode;
      return this.customerByC(clinicCode);
    },
    room() {
      const clinicCode = this.$route.query.clinicCode;
      return this.roomByC(clinicCode);
    },
    needTime() {
      let schlen, checkin = 0; 
      switch(this.tempAcid) {
        case '醫療級果酸+清痘(25分鐘) 1200':
          schlen = 30;
          checkin = 10;
          break;
        case '醫療級清痘(45分鐘) 1500':
          schlen = 60;
          checkin = 10;
          break;
        case '醫療級果酸+清痘(45分鐘) 1800':
          schlen = 60;
          checkin = 10;
          break;
        case '醫療級果酸+清痘+導入(45分鐘) 2200':
          schlen = 60;
          checkin = 10;
          break;
        case '身體果酸(30分鐘) 2500起':
          schlen = 30;
          checkin = 10;
          break;
      }
      return { schlen, checkin, };
    },
    note() {
      return `${this.room.name}(${this.tempAcid})`;
    },
    referralCodeData() {
      const clinicCode = this.$route.query.clinicCode;
      return this.referralCodeDataByC(clinicCode);
    },
    isAirleeClinic() {
      // 檢查當前診所是否為愛爾麗
      if (airleeClinicList.some(clinic => clinic.clinic_sn === this.$route.query.clinicCode)) {
        return true;
      }
      return false;
    },
    mgm_is_enable() {
      const clinicCode = this.$route.query.clinicCode;
      return this.mgmIsEnableByC(clinicCode);
    },
    showReferralCodeCard() {
      // 1) 先判斷是否愛爾麗，愛爾麗不受 mgm_is_enable 控制
      if (this.isAirleeClinic) {
        return true;
      }
      // 2) 一般診所：需 MGM 開關開啟
      return parseInt(this.mgm_is_enable, 10) === 1;
    }
  },
  async created() {
    await this.checkClinic();
    window.scrollTo(0, 0);
  },
};
</script>
